import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TripSearchForm } from '../../shared/trip-search-form/trip-search-form.component';
import { LoginRegisterForm } from '../../shared/login-register-form/login-register-form';
import { LoginWithOtpComponent, OtpMode } from '../../shared/login-with-otp/login-with-otp.component';
import { AuthService } from '../../core/services/auth.service';
import { TripSearchService } from '../../core/services/trip-search.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-home',
    imports: [CommonModule, MatButtonModule, TripSearchForm, LoginRegisterForm, LoginWithOtpComponent],
    templateUrl: './home.html',
    styleUrl: './home.scss'
})
export class Home implements OnInit, OnDestroy {
  @ViewChild('tripSearchForm') tripSearchFormComponent!: TripSearchForm;

  /** Same source as booking-search so selects bind after cities load */
  searchFormData: any = null;

  showLoginRegisterForm = false;
  showOtpLoginForm = false;
  showForgotPasswordForm = false;
  currentOtpMode: OtpMode = 'login';
  private subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private tripSearchService: TripSearchService
  ) {}

  ngOnInit() {
    this.searchFormData = this.tripSearchService.getSearchFormData();

    // Check current auth service state and show appropriate form
    const currentLoginState = this.authService.getCurrentLoginFormState();
   
    
    if (currentLoginState) {
      this.showLoginFormOnHome();
    } else {
      this.showTripSearchFormOnHome();
    }
    
    // Listen to auth service for login form display
    this.subscription.add(
      this.authService.showLoginForm$.subscribe({
        next: (show) => {
         
          if (show) {
            this.showLoginFormOnHome();
          } else {
            // When showLoginForm$ emits false, show trip search form
            this.showTripSearchFormOnHome();
          }
        },
        error: (error) => {
          console.error('Error in showLoginForm$ subscription:', error);
        }
      })
    );

    // Check for query parameters to show login form
    this.subscription.add(
      this.route.queryParams.subscribe(params => {
        
        if (params['showLogin'] === 'true') {
          this.showLoginFormOnHome();
        }
      })
    );

    // Listen for route changes to handle form display when navigating to home
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          
          if (this.router.url === '/' || this.router.url === '/home') {
            
          }
        }
      })
    );

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  showLoginFormOnHome() {
   
    this.showLoginRegisterForm = true;
    this.showOtpLoginForm = false;
    this.showForgotPasswordForm = false;
    
    // Don't reset the service state here - let it stay true while login form is shown
  }

  showOtpLoginFormOnHome() {
  
    this.showLoginRegisterForm = false;
    this.showOtpLoginForm = true;
    this.showForgotPasswordForm = false;
    this.currentOtpMode = 'login';
  }

  showTripSearchFormOnHome() {
  
    this.showLoginRegisterForm = false;
    this.showOtpLoginForm = false;
    this.showForgotPasswordForm = false;
  }

  switchToOtpLogin() {
  
    this.showLoginRegisterForm = false;
    this.showOtpLoginForm = true;
    this.showForgotPasswordForm = false;
    this.currentOtpMode = 'login';
  }

  switchToForgotPassword() {
  
    this.showLoginRegisterForm = false;
    this.showOtpLoginForm = false;
    this.showForgotPasswordForm = true;
    this.currentOtpMode = 'forgot-password';
  }

  switchToRegularLogin() {
   
    this.showLoginRegisterForm = true;
    this.showOtpLoginForm = false;
    this.showForgotPasswordForm = false;
  }

  onPasswordResetSuccess(data: {mobile: string}) {
   
    // Handle password reset success - could show success message and redirect
    this.switchToRegularLogin();
  }

  // Method to handle successful login - hide login form and show trip search
  onLoginSuccess() {
   
    this.authService.hideLoginForm();
  }


}
